import { Components, Theme } from '@mui/material/styles';

const HEIGHT_SM = 34;
const HEIGHT_MD = 44;
const LABEL_FONT_SM = 15;
const LABEL_FONT_MD = 16;
const LABEL_Y_SM = Math.round((HEIGHT_SM - LABEL_FONT_SM - 6) / 2);
const LABEL_Y_MD = Math.round((HEIGHT_MD - LABEL_FONT_MD - 6) / 2);

export const MuiInputLabel: Components<Theme>['MuiInputLabel'] = {
  styleOverrides: {
    outlined: ({ ownerState }) => {
      const small = ownerState.size === 'small';
      const fontSizePx = small ? LABEL_FONT_SM : LABEL_FONT_MD;

      return {
        fontSize: `${fontSizePx}px`,
        transform: `translate(14px, ${
          small ? LABEL_Y_SM : LABEL_Y_MD
        }px) scale(1)`,
        '&.MuiInputLabel-shrink': {
          transform: 'translate(14px, -9px) scale(0.75)',
        },
      };
    },
  },
};
